module.exports = __webpack_public_path__ + "static/p2-95ef421554495bd6cf1c0c38aae69398.jpg";